// 2026-08-23 locale — 14 locales, as-needed prefix, cookie + Accept-Language
"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { Locale } from "@/lib/i18n/locales";
import type { TranslationKey } from "@/lib/i18n/locales";

type Dict = Record<TranslationKey, string> & Record<string, string>;

const LocaleContext = createContext<Locale>("en");
const DictContext = createContext<Record<string, string>>({} as Record<string, string>);

export function LocaleProvider({
  initialLocale,
  initialDict,
  children,
}: {
  initialLocale: Locale;
  initialDict?: Dict | Record<string, string>;
  children: ReactNode;
}) {
  const dict = initialDict ?? ({} as Dict);
  return (
    <LocaleContext.Provider value={initialLocale}>
      <DictContext.Provider value={dict}>{children}</DictContext.Provider>
    </LocaleContext.Provider>
  );
}

export function useLocaleContext(): Locale {
  return useContext(LocaleContext);
}

export function useDictContext(): Record<string, string> {
  return useContext(DictContext);
}
